var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3a5 5 0 0 0-5 5c0 3.647-.783 6.065-1.622 7.604q-.114.21-.229.396h13.702a9 9 0 0 1-.229-.396C17.782 14.065 17 11.647 17 8a5 5 0 0 0-5-5m9.566 13.176-.003-.002-.052-.042a3 3 0 0 1-.254-.242 6 6 0 0 1-.88-1.244C19.718 13.435 19 11.353 19 8A7 7 0 1 0 5 8c0 3.353-.717 5.435-1.378 6.646a6 6 0 0 1-.88 1.244 3 3 0 0 1-.308.286A1 1 0 0 0 3 18h18a1 1 0 0 0 .566-1.824M9.818 20.124a1 1 0 0 1 1.358.394.94.94 0 0 0 1.648 0 1 1 0 0 1 1.752.964 2.94 2.94 0 0 1-5.152 0 1 1 0 0 1 .394-1.358",
    clipRule: "evenodd"
  })));
};
export default SvgBell;